import AppSettings from "../../../core/AppSettings";

export default class HelpInfo {
  constructor() {
    this.mainClass = ".aam-designer-init";
    this.rootElement = document.querySelector(this.mainClass);
    this.mainContainer = this.rootElement.querySelector(".main-container");

    this.popupHandler();
  }

  // Handle help popup
  popupHandler() {
    const btnInfo = this.rootElement.querySelector("#btn-info");
    const helpPage = this.rootElement.querySelector(".help-page");

    // add title from lang file on button
    btnInfo.setAttribute("aria-label", AppSettings.Language.info || 'Help');
    btnInfo.setAttribute("title", AppSettings.Language.info || 'Help');

    // show popup
    btnInfo.onclick = () => {
      helpPage.classList.add("help-page-open");
      this.mainContainer.classList.add("blur-page");
    };

    this.close(helpPage);
  }

  close(helpPage) {
    const closeHelpInfo = this.rootElement.querySelector('.close-help-page');
    if (closeHelpInfo) {
      closeHelpInfo.onclick = () => {
        helpPage.classList.remove("help-page-open");
        this.mainContainer.classList.remove("blur-page");
      };
    }
  }

  mobile() {
    // const helpPageDesktop = this.parentElement.parentElement.querySelector(
    //   ".help-page.desktop"
    // );
    // const helpPageMobile = this.parentElement.parentElement.querySelector(
    //   ".help-page.mobile"
    // );
    // if (this.parentElement.parentElement.classList.contains("mobile")) {
    //   if (helpPageDesktop) {
    //     //helpPageDesktop.remove();
    //   }
    // } else {
    //   if (helpPageMobile) {
    //     //helpPageMobile.remove();
    //   }
    // }
  }
}
